import { render, staticRenderFns } from "./SigStepNavStep.vue?vue&type=template&id=36dd7db2"
import script from "./SigStepNavStep.vue?vue&type=script&lang=ts"
export * from "./SigStepNavStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports